export const ADMIN_COLOR_SCHEME_ANALYTICS_SOURCE = 'adminColorScheme';
export const PATH_NAME = '/admin/color-scheme';
